import classNames from "classnames"

import { StaffLabelTextS } from "@doktor-se/bones-ui"

import styles from "./FilterButton.module.scss"

interface FilterButtonProps {
  filter: string
  label: string
  onClick: (key: string) => void
  active: boolean
  notification?: boolean
}

const FilterButton = ({ filter, label, onClick, active, notification }: FilterButtonProps) => (
  <button className={classNames(styles.button, { [styles.active]: active })} onClick={() => onClick(filter)}>
    {notification && <div className={styles.notification} />}
    <StaffLabelTextS>{label}</StaffLabelTextS>
  </button>
)

export default FilterButton
